import React from 'react'

const HeadingText = ({ label, heading, position, text }) => {
  return (
    <div className={`${position === 'center' ? 'text-center' : 'text-left'} `}>
      <h6 className='uppercase text-[#A4AEB5] xl:text-sm text-xs font-semibold'>{label}</h6>
      <h1 className={`xl:text-5xl sm:text-4xl text-3xl leading-tight ${text ? 'text-white' : 'text-primaryTextColor'} mt-2 capitalize font-semibold`}>{heading}</h1>
    </div>
  )
}

export default HeadingText